<template>
    <div class="advanced-search-wrapper" id="advanced-search-vue">
        <div class="container form-group">
            <div class="search-large-tx pb-4">Advanced Product Filter</div>
            <div class="pb-2">
                Search for products that match the following conditions:
            </div>
            <div v-for="(query, index) in queries" :key="'search-' + index">
                <div v-if="false" class="pb-2 pt-1 pl-3 pr-2 w-25">
                    <select class="form-control form-height-thin" aria-label="query where selector"
                        v-model="multiQueryOperator">
                        <option>and</option>
                        <option>or</option>
                    </select>
                </div>

                <div class="d-flex position-relative">
                    <div class="and-operation" v-if="index > 0">and</div>
                    <div class="py-2 pl-0 pr-2 w-25">
                        <select class="form-control" aria-label="query where selector" v-model="query.whereData"
                            @change="checkWhereValueChange(index)">
                            <option v-for="searchItem in searchables" :key="'where-' + searchItem.label"
                                :value="searchItem">
                                {{ searchItem.label }}
                            </option>
                        </select>
                    </div>
                    <div class="p-2 w-25">
                        <select class="form-control" aria-label="query where selector" v-model="query.condition"
                            @change="generateURL">
                            <option v-for="condition in conditionTypesForQueryOfIndex(
                                index
                            )" :key="'s-condition-' + condition.label" :value="condition">
                                {{ condition.label }}
                            </option>
                        </select>
                    </div>

                    <div class="p-2 w-50" v-if="showQueryValueForSelectableInput(index)">
                        <div>
                            <input type="text" class="form-control cursor-pointer" placeholder="Select Below" disabled
                                aria-label="value text" v-model="query.value" />
                        </div>
                    </div>
                    <div class="p-2 w-50" v-else-if="showQueryHasOptions(index)">
                        <select class="form-control" aria-label="value select" v-model="query.value"
                            @change="generateURL">
                            <option v-for="query_option in query.whereData
                            .attribute_values" :value="query_option.value" :key="query_option.id">
                                {{ query_option.value }}
                            </option>
                        </select>
                    </div>
                    <div class="p-2 w-50" v-else-if="showQueryValueInputForIndex(index)">
                        <input type="text" class="form-control" placeholder="Value" aria-label="value text"
                            v-model="query.value" @change="generateURL" />
                    </div>

                    <div class="p-2 w-25" v-if="queries[index].conditionType === 'boolean'">
                        &nbsp;
                    </div>
                    <div class="p-2 w-25 d-flex justify-content-end">
                        <button v-if="showQueryValueForSelectableInput(index)" class="btn btn-secondary btn-rgl"
                            @click="editQueryValueForSelectableInput(index)">
                            Edit
                        </button>
                        <button class="btn btn-secondary btn-rgl" @click="removeQueryLine(index)">
                            <span class="fa fa-times pr-2"></span>Remove
                        </button>
                    </div>
                </div>

                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Attribute For Search (Only filterable attributes)" v-if="showList(selectableTypes.ATTRIBUTE, index)" api-type="grid" :api="attibutesAPI" :columns="['name', 'type']" @selection="handleAttributeSelectionForIndex(index, ...arguments)"></selection-lister>
                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Workflow For Search" v-if="showList(selectableTypes.WORKFLOWS, index)" api-type="grid" :api="workflowAPI" :columns="['name', 'description']" @selection="handleSelectionForIndex(index, ...arguments)" extra-query="no_count=true"></selection-lister>
                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Brand For Search" v-if="showList(selectableTypes.BRAND, index)" api-type="grid" :api="brandAPI" :columns="['name', 'product_count']" @selection="handleSelectionForIndex(index, ...arguments)"></selection-lister>
                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Brand ID For Search" v-if="showList(selectableTypes.BRAND_ID, index)" api-type="grid" :api="brandAPI" :columns="['id', 'product_count']" @selection="handleSelectionForIndex(index, ...arguments)"></selection-lister>
                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Category For Search" v-if="showList(selectableTypes.CATEGORY, index)" api-type="grid" :api="categoryAPI" :columns="['qualifiedName']" @selection="handleSelectionForIndex(index, ...arguments)"></selection-lister>
                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Category ID For Search" v-if="showList(selectableTypes.CATEGORY_ID, index)" api-type="grid" :filter-on="'id'" :api="categoryAPI" :columns="['id']" @selection="handleSelectionForIndex(index, ...arguments)"></selection-lister>
                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Channel For Search" v-if="showList(selectableTypes.CHANNEL, index)" api-type="grid" :api="channelAPI" :columns="['channel_name']" @selection="handleSelectionForIndex(index, ...arguments)"></selection-lister>
                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Generic Entity Value For Search" v-if="showList(selectableTypes.CONCRETE_ENTITY, index)" api-type="grid" :api="entityAPI" :columns="['name']" @selection="handleSelectionForIndex(index, ...arguments)"></selection-lister>
                <selection-lister ref="selector" class="pl-0 pr-2 w-100" :results-per-page="10" list-label="Select Generic Entity Relation Type Value For Search" v-if="showList(selectableTypes.RELATED_CONCRETE_ENTITY, index)" api-type="grid" :api="relatedEntityAPI" :columns="['name']" @selection="handleSelectionForIndex(index, ...arguments)"></selection-lister>
            </div>
            <div class="d-flex justify-content-start py-2 pl-0 pr-2 w-75">
                <button class="btn btn-secondary mr-3 btn-rgl" @click="addNewQueryLine">
                    <span class="fa fa-plus pr-2"></span>Add New Condition
                </button>
                <button class="btn btn-primary btn-rgl" @click="submitSearch">
                    <span class="fa fa-search pr-2"></span>Filter
                </button>
                <button class="btn btn-primary btn-rgl btn-project" @click="toggleProjectView">
                    <span v-if="editProject">
                        <span class="fa fa-minus pr-2"></span>
                        Hide Project View
                    </span>
                    <span v-else>
                        <span class="fa fa-plus pr-2"></span>
                        Edit as Project
                    </span>
                </button>
            </div>

            <transition name="fade">
                <div v-if="editProject">
                    <transition name="fade">
                        <div v-if="assignedUsersModal" class="modal-wrapper">
                            <div class="modal-bg" @click="assignedUsersModal = false"></div>
                            <workflow-assigned-users v-if="isProject" :is-project="isProject" :project-workflow-id="projectId"></workflow-assigned-users>
                        </div>
                        <div v-if="restrictUserModal" class="modal-wrapper">
                            <div class="modal-bg" @click="restrictUserModal = false"></div>
                            <project-restrict-user v-if="isProject"
                                :is-project="isProject"
                                :project-id="projectId"
                                :pending-users="pendingProjectUsers"
                                :pending-roles="pendingProjectRoles">
                            </project-restrict-user>
                        </div>
                    </transition>
                    <div class="form-horizontal throttle">
                        <div class="form-group project-form">
                            <div class="d-flex flex-column max-w-md">
                                <label for="name">Name</label>
                                <div>
                                    <input v-model="project.name" id="name" type="text" name="name" class="form-control" />
                                    <div v-if="(project.name.length === 0 && hasEnteredName) || (project.name.length === 0 && projectId)" class="text-danger mt-1">
                                        Name value is required
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column max-w-md mb-2 mt-4">
                                <label for="name">Description</label>
                                <div>
                                    <input v-model="project.desc" id="desc" type="text" name="desc" class="form-control" />
                                </div>
                            </div>
                            <div class="d-flex align-items-center my-4" v-if="isAssignedToProject">
                                <div class="btn btn-link text-muted px-0 d-flex" @click="openRestrictUserModal">
                                    Restrict to Users +
                                </div>
                            </div>
                            <div class="d-flex">
                                <button class="btn btn-primary btn-sm" type="button" @click="handleNewProject()"
                                    :disabled="
                                        project.name.length === 0 ||
                                        project.buttonDisabled
                                    ">
                                    Save as New Project
                                </button>
                                <button v-if="projectId.length" class="btn btn-outline-primary btn-sm ml-1"
                                    type="button" @click="handleExistingProject()" :disabled="
                                        project.name.length === 0 ||
                                        project.buttonDisabled
                                    ">
                                    Save Existing Project
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import SelectItemFromAPIprovidedList from "../../generic/select-item-from-api-provided-list.vue";
import constants from "../../../search-constants";
import BasePagination from "../../tables/base-pagination.vue";
import BasePaginationInfo from "../../tables/base-pagination-info.vue";
import ProjectRestrictUser from "./project-restrict-user.vue";
import WorkflowAssignedUsers from "./workflow-assigned-users.vue";

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "advanced-product-search",
    components: {
        "selection-lister": SelectItemFromAPIprovidedList,
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
        "project-restrict-user": ProjectRestrictUser,
        "workflow-assigned-users": WorkflowAssignedUsers,
    },
    props: {
        simpleSearch: {
            type: String,
            default: "",
        },
        projectId: {
            type: [Number, String],
        },
        userId: {
            type: [Number, String],
        },
        searchId: {
            type: [String, Number],
        },
        searchName: {
            type: [String],
        },
        searchDesc: {
            type: [String],
            default: "",
        },
        isNewProject: {
            type: [Boolean],
            default: false
        }
    },
    data() {
        return {
            isAssignedToProject: false,
            pendingProjectUsers: [],
            pendingProjectRoles: [],
            availableProjectRoles: [],
            hasEnteredName: false,
            restrictUserModal: false,
            assignedUsersModal: false,
            editProject: false,
            base_url: window.location.protocol + "//" + window.location.host,
            isProject: false,
            project: {
                name: "",
                desc: "",
                buttonDisabled: false,
                queryState: "",
                userSavedSearchId: 0,
            },
            selectableTypes: constants.selectableTypes,
            listShowing: "",
            active_condition_index: 0,
            filterShowing: true,
            multiQueryOperator: "and",
            queries: [this.getEmptyQueryObject()],
            params: {},
            queryState: "",
            searchables: [
                { label: 'Name', value: 'name', type: 'string'},
                { label: 'Is enabled', value: 'enabled', type: 'boolean'},
                { label: 'Description', value: 'description', type: 'string'},
                { label: 'Long Description', value: 'long_description', type: 'string'},
                { label: 'Warranty Info', value: 'warranty_info', type: 'string'},
                { label: 'SKU', value: 'sku', type: 'string'},
                { label: "Brand", value: constants.selectableTypes.BRAND, type: 'string'},
                { label: 'Brand ID', value: constants.selectableTypes.BRAND_ID, type: 'string'},
                { label: 'Saleable Inventory', value: 'inventory', type: 'float'},
                { label: 'On Hand Inventory', value: 'quantity', type: 'float'},
                { label: 'Web ID', value: 'web_id', type: 'string'},
                { label: 'ID', value: 'id', type: 'float'},
                { label: 'Is visible', value: 'is_visible', type: 'boolean'},
                { label: 'Is featured', value: 'is_featured', type: 'boolean'},
                { label: 'Has cost price', value: 'has_cost_price', type: 'boolean'},
                { label: 'Has map price', value: 'has_map_price', type: 'boolean'},
                { label: 'Has msrp price', value: 'has_msrp_price', type: 'boolean'},
                { label: 'Category', value: constants.selectableTypes.CATEGORY, type: 'string'},
                { label: 'Category ID', value: 'category_ids', type: 'string'},
                { label: 'Category Name', value: 'category_name', type: 'string'},
                { label: 'Has category', value: 'categorization_status', type: 'boolean'},
                { label: 'Channel', value: constants.selectableTypes.CHANNEL, type: 'string'},
                { label: 'Tag', value: 'tags', type: 'string'},
                { label: 'Is online', value: 'is_online', type: 'boolean'},
                { label: 'Has content', value: 'content_status', type: 'boolean'},
                { label: 'Has inventory', value: 'inventory_status', type: 'boolean'},
                { label: 'Has photo', value: 'photo_status', type: 'boolean'},
                { label: 'Has price expiring soon', value: 'has_price_expiring_soon', type: 'boolean'},
                { label: 'Has pricing', value: 'pricing_status', type: 'boolean'},
                { label: 'Has sell price', value: 'has_sell_price', type: 'boolean'},
                { label: 'Workflow', value: constants.selectableTypes.WORKFLOWS, type: 'string'},
                { label: 'Weight', value: 'shipping_weight', type: 'float'},
                { label: 'Generic Entity Value', value: constants.selectableTypes.CONCRETE_ENTITY, type: 'string'},
                { label: 'Generic Entity Relation Type Value', value: constants.selectableTypes.RELATED_CONCRETE_ENTITY, type: 'string'},
                { label: '+ Add Attribute', value: constants.selectableTypes.ATTRIBUTE, type: 'string'},
                // { label: '+ Add Generic Entity', value: constants.selectableTypes.GENERICENTITY, type: 'string'},
            ]
        };
    },
    created() {
        this.getParams();

        if (this.params.has("query")) {
            this.useQueryParam();
        } else if (this.params.has("category")) {
            this.queries[0].whereData.label = "Category ID";
            this.queries[0].whereData.value = "category_ids";
            this.queries[0].value = this.params.get("category");
            this.generateURL();
        } else if (this.params.has("brand")) {
            this.queries[0].whereData.label = "Brand ID";
            this.queries[0].whereData.value = "brand_id";
            this.queries[0].value = this.params.get("brand");
            this.generateURL();
        }
        // fetch the product
        this.$nextTick(() => {
            this.submitSearch();
        });
    },
    mounted() {
        if (this.projectId) {
            axios.get(`${base_url}/pimapi/projects/${this.projectId}/users`)
                .then((response) => {
                    this.isAssignedToProject =
                        response.data.payload.includes((user) => user.id == this.userId);
                })
                .catch((error) => {
                    console.log(error);
                })
        }

        if (this.searchName.length) {
            this.project.name = this.searchName;
        }
        if (this.searchDesc.length) {
            this.project.desc = this.searchDesc;
        }
        if (this.searchId.length) {
            this.project.userSavedSearchId = this.searchId;
        }

        if (this.isNewProject || this.projectId) {
            this.toggleProjectView();
        }
        this.project.queryState = window.location.href;

        this.active_condition_index = this.queries.length - 1;

        const queryString = window.location.search;

        if (queryString.includes('created')) {
            this.$emit("alert", {
                status: 'alert-success',
                message: 'Project saved successfully.'
            });
        }
    },
    computed: {
        selectValues() {
            return Object.values(constants.selectableTypes);
        },
        getQuery() {
            let url = this.project.queryState;
            return url.split("query=")[1];
        },
        queryStringified() {
            return JSON.stringify(this.queries);
        },
        stringToBase64() {
            return btoa(this.queryStringified);
        },
        base64ToString() {
            return atob(this.stringToBase64);
        },
        attibutesAPI() {
            return "/attributes/gridsearchable";
        },
        brandAPI() {
            return "/brands/grid";
        },
        workflowAPI() {
            return "/pimapi/workflows";
        },
        categoryAPI() {
            return "/categories/grid";
        },
        channelAPI() {
            return "/channels/grid";
        },
        entityAPI() {
            return "/pimapi/concrete-entities";
        },
        relatedEntityAPI() {
            return "/pimapi/related-concrete-entities";
        },
        multiQueryOperators() {
            return ["and", "or"];
        },
        numberOfQueries() {
            return this.queries.length;
        },
        booleanConditions() {
            return [
                { label: "Select", value: "" },
                { label: "Yes", value: true },
                { label: "No", value: false },
            ];
        },
        stringConditions() {
            return [
                { label: "Contains", value: "contains" },
                { label: "Doesn't Contain", value: "doesn't contain" },
                { label: "Is Empty", value: constants.IS_EMPTY },
                { label: "Is Not Empty", value: constants.IS_NOT_EMPTY },
            ];
        },
        floatConditions() {
            return [
                { label: "Equals", value: "is" },
                { label: "Greater", value: "gt" },
                { label: "Greater or Equal", value: "gte" },
                { label: "Less", value: "lt" },
                { label: "Less or Equal", value: "lte" },
                { label: "Is Empty", value: constants.IS_EMPTY },
                { label: "Is Not Empty", value: constants.IS_NOT_EMPTY },
            ];
        }
    },
    watch: {
        // triggers a search when a simple search term in added from the parent component
        simpleSearch: function (nVal, oVal) {
            if (nVal !== oVal) {
                this.$nextTick(() => {
                    this.generateURL();
                    this.submitSearch();
                });
            }
        },
        project: {
            handler(nVal, oVal) {
                if (!this.hasEnteredName && this.project.name.length > 0) {
                    this.hasEnteredName = true;
                }
            },
            deep: true
        }
    },
    methods: {
        toggleProjectView() {
            this.isProject = true;
            this.editProject = !this.editProject;
        },
        showList(list, idx) {
            return (
                this.active_condition_index == idx && this.listShowing === list
            );
        },
        setList(idx) {
            if (
                !this.queries[idx] ||
                this.queries[idx].condition.value === constants.IS_EMPTY ||
                this.queries[idx].condition.value === constants.IS_NOT_EMPTY
            ) {
                this.clearListShowing();
                return;
            }

            let list_value = this.queries[idx].whereData.value;
            this.listShowing = list_value ? list_value : "";
        },
        clearListShowing() {
            this.listShowing = "";
        },
        handleExistingProject() {
            this.project.buttonDisabled = true;

            axios
                .put("/pimapi/userSavedSearches/" + this.project.userSavedSearchId, {
                    name: this.project.name,
                    desc: this.project.desc,
                    data: this.getQuery
                })
                .then(res => {
                    axios.put('/pimapi/projects/' + this.projectId, {
                        name: this.project.name,
                        desc: this.project.desc,
                        data: this.getQuery,
                        user_saved_search_id: this.project.userSavedSearchId
                    })
                    .then((res) => {
                        this.project.buttonDisabled = false;

                        this.$emit("alert", {
                            status: 'alert-success',
                            message: 'Updated successfully'
                        });
                    })
                    .catch((err) => {
                        this.project.buttonDisabled = false;

                        this.$emit("alert", {
                            status: 'alert-danger',
                            message: err.response.data.message
                        });
                    })
                })
                .catch((err) => {
                    this.project.buttonDisabled = false;

                    this.$emit("alert", {
                        status: 'alert-danger',
                        message: 'Error updating project'
                    });
                })
        },
        handleNewProject() {
            this.project.buttonDisabled = true;

            const projectPayload = {
                name: this.project.name,
                data: this.getQuery,
                desc: this.project.desc
            };

            const savedSearchPayload = {
                name: this.project.name,
                desc: this.project.desc,
                data: this.getQuery
            };

            if (this.pendingProjectRoles.length) {
                projectPayload.roleIds = this.pendingProjectRoles.map((r) => r.id);
            };

            if (this.pendingProjectUsers.length) {
                projectPayload.userIds = this.pendingProjectUsers.map((u) => u.id);
            };

            axios
                .post("/pimapi/userSavedSearches", savedSearchPayload)
                .then(res => {
                    projectPayload.user_saved_search_id = res.data.data.id;
                    if (this.isProject) {
                        axios.post(`/pimapi/projects`, projectPayload)
                        .then((response) => {
                            this.project.buttonDisabled = false;

                            const queryParams = {
                                project: response.data.data.id,
                                search_id: projectPayload.user_saved_search_id,
                                name: projectPayload.name,
                                desc: projectPayload.desc,
                                created: '1',
                                query: projectPayload.data,
                            };

                            const queryParamString = new URLSearchParams(queryParams).toString();
                            const url = base_url + '/products/?' + queryParamString;

                            this.$nextTick(() => {
                                window.location.href = url;
                            });
                        })
                        .catch((err) => {
                            this.project.buttonDisabled = false;

                            this.$emit("alert", {
                                status: 'alert-danger',
                                message: err.response.data.message
                            });
                        })
                    }
                    else {
                        this.project.buttonDisabled = false;
                        this.$emit("alert", {
                            status: 'alert-success',
                            message: 'Search saved successfully.'
                        });
                    }
                })
                .catch((err) => {
                    this.project.buttonDisabled = false;
                    console.log(err)
                    this.$emit("alert", {
                        status: 'alert-danger',
                        message: 'An error occurred saving your project or search'
                    });
                })
            // if we don't have a search what we do? disable the button
            // then use the saved_search id to create the project, all in a single call.
        },
        conditionTypesForQueryOfIndex(idx) {
            if (
                this.queries[idx].conditionType === "string" ||
                this.queries[idx].conditionType === "select"
            ) {
                return this.stringConditions;
            } else if (this.queries[idx].conditionType == "float") {
                return this.floatConditions;
            }
            return this.booleanConditions;
        },
        showQueryValueInputForIndex(idx) {
            if (this.queries[idx].conditionType === "boolean") {
                return false;
            }
            //the selectableTypes use a different input
            if (this.selectValues.includes(this.queries[idx].whereData.value)) {
                return false;
            }
            return (
                this.queries[idx].condition.value !== constants.IS_EMPTY &&
                this.queries[idx].condition.value !== constants.IS_NOT_EMPTY
            );
        },
        showQueryHasOptions(idx) {
            return (
                this.queries[idx].whereData.attribute_values &&
                this.queries[idx].whereData.attribute_values.length > 0
            );
        },
        showQueryValueForSelectableInput(idx) {
            if (this.selectValues.includes(this.queries[idx].whereData.value)) {
                if (
                    this.queries[idx].condition.value !== constants.IS_EMPTY &&
                    this.queries[idx].condition.value !== constants.IS_NOT_EMPTY
                ) {
                    return true;
                }
            }
            return false;
        },
        editQueryValueForSelectableInput(idx) {
            if (this.selectValues.includes(this.queries[idx].whereData.value)) {
                if (
                    this.queries[idx].condition.value !== constants.IS_EMPTY &&
                    this.queries[idx].condition.value !== constants.IS_NOT_EMPTY
                ) {
                    this.setActiveConditionIndex(idx);
                }
            }
            return false;
        },
        queryToPost() {
            //converts the query JSON into a simplified POST data object.
            let payloadForAPI = {
                operator: this.multiQueryOperator,
                constraints: [],
            };

            this.queries.forEach((query) => {
                if (query.whereData.value === "attribute") {
                    payloadForAPI.constraints.push({
                        constraint: query.condition.value,
                        attribute: query.attributeName,
                        attribute_id: query.attributeId,
                        value: query.value,
                    });
                } else if (query.whereData.type === "boolean") {
                    payloadForAPI.constraints.push({
                        constraint: "is",
                        field: query.whereData.value,
                        value: query.condition.value,
                    });
                } else if (
                    query.condition.value === "contains" &&
                    query.value === ""
                ) {
                    //skip because will always return zero results (and likely the default unset search query)
                } else {
                    payloadForAPI.constraints.push({
                        constraint: query.condition.value,
                        field: query.whereData.value,
                        value: query.value,
                    });
                }
            });

            payloadForAPI.simpleSearch = $("#search_string").val();

            return payloadForAPI;
        },
        postToQuery(post) {
            /* converts the simplified POST data object to a JSON object this UI is expecting. */

            if (post.simpleSearch !== "") {
                this.$nextTick(() => {
                    $("#search_string").val(post.simpleSearch);
                });
            }

            this.multiQueryOperator = post.operator;
            this.queries = [];

            if (post.constraints.length > 0) {
                post.constraints.forEach((el) => {
                    let q = this.getEmptyQueryObject();
                    q.value = el.value;

                    if (el.hasOwnProperty("attribute")) {
                        this.searchables.push({
                            attributeId: el.attribute_id,
                            attributeName: el.attribute,
                            label: "Attribute: " + el.attribute,
                            type: "string",
                            value: "attribute",
                        });
                    }

                    //search for property type
                    this.searchables.forEach((searchable) => {
                        if (el.hasOwnProperty("field")) {
                            if (searchable.value === el.field) {
                                q.whereData.label = searchable.label;
                                q.whereData.type = searchable.type;
                                q.whereData.value = searchable.value;
                                q.conditionType = searchable.type;
                                q.lastConditionType = searchable.type;
                            }
                        }

                        if (el.hasOwnProperty("attribute")) {
                            if (searchable.attributeName == el.attribute) {
                                q.whereData.attributeId =
                                    searchable.attributeId;
                                q.whereData.attributeName =
                                    searchable.attributeName;
                                q.whereData.label = searchable.label;
                                q.whereData.type = searchable.type;
                                q.whereData.value = "attribute";
                                q.conditionType = searchable.type;
                                q.lastConditionType = searchable.type;
                            }
                        }
                    });

                    //is this an attribute?
                    if (el.hasOwnProperty("attribute")) {
                        q.attributeId = el.attribute_id;
                        q.attributeName = el.attribute;
                        q.condition.value = el.constraint;
                        q.condition.label = "";
                        this.stringConditions.forEach((stringCondition) => {
                            if (el.constraint == stringCondition.value) {
                                q.condition.label = stringCondition.label;
                            }
                        });
                    } else if (q.whereData.type === "boolean") {
                        q.value = "";
                        q.condition.value = el.value;
                        q.condition.label = "";
                        this.booleanConditions.forEach((boolCon) => {
                            if (boolCon.value === el.value) {
                                q.condition.label = boolCon.label;
                            }
                        });
                    } else {
                        q.condition.value = el.constraint;
                        q.condition.label = "";
                        this.stringConditions.forEach((stringCondition) => {
                            if (el.constraint == stringCondition.value) {
                                q.condition.label = stringCondition.label;
                            }
                        });
                        q.condition.label = "";
                        if (q.whereData.type === "float") {
                            this.booleanConditions.forEach(
                                (booleanCondition) => {
                                    if (
                                        el.constraint === booleanCondition.value
                                    ) {
                                        q.condition.label =
                                            booleanCondition.label;
                                    }
                                }
                            );
                        } else {
                            this.stringConditions.forEach((stringCondition) => {
                                if (el.constraint == stringCondition.value) {
                                    q.condition.label = stringCondition.label;
                                }
                            });
                        }
                    }

                    this.queries.push(q);
                });
            } else {
                //add default constaint
                this.queries.push(this.getEmptyQueryObject());
            }
        },
        submitSearch() {
            let q = this.queryToPost();

            if (q.constraints.length === 0 && q.simpleSearch === "") {
                this.$emit("searchQueryUpdate", "");
            } else {
                this.$emit("searchQueryUpdate", JSON.stringify(q));
            }
            this.$emit("handleAdvancedSearchSubmit");
        },
        checkWhereValueChange(idx) {
            this.setList(idx);

            if (this.queries[idx].whereData.hasOwnProperty("attributeId")) {
                this.queries[idx].attributeName =
                    this.queries[idx].whereData.attributeName;
                this.queries[idx].attributeId =
                    this.queries[idx].whereData.attributeId;
            } else {
                this.queries[idx].attributeName = "";
                this.queries[idx].attributeId = "";
            }

            this.queries[idx].conditionType = this.queries[idx].whereData.type;
            if (
                this.queries[idx].whereData.type !=
                this.queries[idx].lastConditionType
            ) {
                let qConditions = this.conditionTypesForQueryOfIndex(idx);
                this.queries[idx].condition = qConditions[0];
                this.queries[idx].lastConditionType =
                    this.queries[idx].whereData.type;
            }

            //clear out the search selector so they will have to reselect when Search Type is changed
            if (this.$refs.selector && this.$refs.selector[0]) {
                this.$refs.selector[0].selectedItem = {};
            }

            this.queries[idx].value = "";
        },
        addNewQueryLine() {
            this.queries.push(this.getEmptyQueryObject());
            this.clearActiveConditionIndex();
        },
        removeQueryLine(idx) {
            this.queries.splice(idx, 1);
            this.clearActiveConditionIndex();
            if (this.queries.length < 1) {
                $("#advancedSearchButton").css({ color: "#rgb(29, 76, 111)" });
            }
            this.generateURL();
        },
        setActiveConditionIndex(set_index) {
            this.active_condition_index = set_index;
            this.setList(this.active_condition_index);
        },
        clearActiveConditionIndex() {
            this.active_condition_index = this.queries.length - 1;
            this.setList(this.active_condition_index);
        },
        getEmptyQueryObject() {
            return {
                whereData: { label: "Name", value: "name", type: "string" },
                condition: { label: "Contains", value: "contains" },
                attributeName: "",
                attributeId: "",
                value: "",
                conditionType: "string",
                lastConditionType: "string",
            };
        },
        handleAttributeSelectionForIndex(idx, args) {
            var condition_type = "string";
            var condition_type_values = [];
            if (args.type_values && args.type_values.length > 0) {
                condition_type = "select";
                condition_type_values = args.type_values.map((tv) => {
                    return {
                        id: tv.id,
                        value: tv.value,
                    };
                });
            }

            //do not allow duplicate search options of an attribute
            let searchable_label = "Attribute: " + args.name;
            let searchable_index = this.searchables.findIndex(
                (searchable) => searchable.label == searchable_label
            );
            let searchable = {
                label: "Attribute: " + args.name,
                value: "attribute",
                type: condition_type,
                attributeName: args.name,
                attributeId: args.id,
                attribute_values: condition_type_values,
            };
            if (searchable_index == -1) {
                this.searchables.push(searchable);
            } else {
                this.searchables[searchable_index] = searchable;
            }

            this.queries[idx].whereData = searchable;
            this.queries[idx].attributeName = args.name;
            this.queries[idx].attributeId = args.id;
            this.clearListShowing();
            this.generateURL();
        },
        handleSelectionForIndex(idx, args) {
            if (
                this.queries[idx].whereData.value ===
                this.selectableTypes.CHANNEL
            ) {
                this.queries[idx].value = args.channel_name;
            } else if (
                this.queries[idx].whereData.value ===
                this.selectableTypes.CATEGORY
            ) {
                this.queries[idx].value = args.qualifiedName;
            } else if (
                this.queries[idx].whereData.value ===
                this.selectableTypes.CATEGORY_ID
            ) {
                this.queries[idx].value = args.id;
            } else if (
                this.queries[idx].whereData.value ===
                this.selectableTypes.BRAND_ID
            ) {
                this.queries[idx].value = args.id;
            } else {
                this.queries[idx].value = args.name;
            }
            this.clearListShowing();
            this.generateURL();
        },
        generateURL() {
            let q = this.queryToPost();
            q = JSON.stringify(q);
            let encoder = new TextEncoder("utf-8");
            q = encoder.encode(q);
            q = q.join(' ');
            let q64 = window.btoa(q);
            let newUrl = this.updateURLParameter(
                window.location.href,
                "query",
                q64
            );
            window.history.replaceState("", "", newUrl);
            this.project.queryState = newUrl;
        },
        updateURLParameter(url, param, paramVal) {
            let newAdditionalURL = "";
            let tempArray = url.split("?");
            let baseURL = tempArray[0];
            let rows_txt = param + "=" + paramVal;
            return baseURL + "?" + newAdditionalURL + rows_txt;
        },
        useQueryParam() {
            this.getParams();
            if (this.params.has("query")) {
                let param = this.params.get("query");
                param = param.replace(/ /g, '+');

                try {
                    //new method => no more uri encoding, works with multibyte characters
                    let q = window.atob(param);
                    let byteArray = new Uint8Array(q.split(" ").map(byte => parseInt(byte, 10)));
                    let decoder = new TextDecoder("utf-8");
                    q = decoder.decode(byteArray);
                    q = JSON.parse(q);
                    this.postToQuery(q);
                } catch (e) {
                    console.log("Error: " + e.message);
                    this.$emit("alert", {
                        status: 'alert-danger',
                        message: "Error parsing the search query."
                    });
                }
            }
        },
        getParams() {
            this.params = new URLSearchParams(
                window.location.search.substring(1)
            );
        },
        hideFilterPanel() {
            $("#search_advanced").collapse("hide");
        },
        openAssignedUsersModal() {
            this.assignedUsersModal = true;
        },
        openRestrictUserModal() {
            this.restrictUserModal = true;
        },
    },
};
</script>

<style scoped lang="scss">
.btn-rgl {
    font-weight: 400;
}

.search-large-tx {
    font-size: 1.7em;
}

.form-height-thin {
    height: 26px;
    padding: 0px 10px;
}

.form-control:read-only {
    background-color: white;
}

.and-operation {
    position: absolute;
    top: 18px;
    left: -26px;
}

.btn-project {
    margin-left: 16px;
    background-color: #3cab9f !important;
    border-color: #3cab9f !important;
}

.project-form {
    margin-top: 2rem;

    .row+.row {
        margin-top: auto !important;
    }
}
</style>
